module.exports = __webpack_public_path__ + "img/AppStore.9b3175c3.png";